// extracted by mini-css-extract-plugin
export default {"postPage":"mFmpGg","emptyState":"vkmZxG","recentPosts":"EfqCvP","aboveContentSlot":"oWLROm","pageBottomSlot":"iatMsC","mobileContainer":"nNF28C"};